import UniqueResultParametersProvider from "./UniqueResultParametersProvider.js";
import BaseballResultsProcessor from "../entities/BaseballResultsProcessor.js";

const UniqueParametersForPitchAndHitProvider = function(
    pitchParameters, hitParameters, pitchToHitParamsToMerge,
    filteredPitches, filteredHits, customResultsProcessor, combinedPitchResult
) {
    if ( !(pitchParameters instanceof Array)) {
        throw new TypeError('pitchParameters must be an array');
    }

    if ( !(hitParameters instanceof Array)) {
        throw new TypeError('hitParameters must be an array');
    }

    if ( !(pitchToHitParamsToMerge instanceof Array)) {
        throw new TypeError('pitchToHitParamsToMerge must be an array');
    }

    if ( !(filteredPitches instanceof Array)) {
        throw new TypeError('filteredPitches must be an array');
    }

    if ( !(filteredHits instanceof Array)) {
        throw new TypeError('filteredHits must be an array');
    }

    const resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    const uniqueParamsForPitches = UniqueResultParametersProvider(filteredPitches, pitchParameters, resultsProcessor, combinedPitchResult);
    const uniqueParamsForHits = UniqueResultParametersProvider(filteredHits, hitParameters, resultsProcessor, combinedPitchResult);
    const uniqueParams = new Map();

    // get common part
    for (let i = 0; i < pitchToHitParamsToMerge.length; i++) {
        if (typeof(pitchToHitParamsToMerge[i]) === 'undefined') {
            continue;
        }

        const pitchParameter = pitchParameters[i];
        const hitParameter = hitParameters[pitchToHitParamsToMerge[i]];

        if (typeof(pitchParameter) === 'undefined') {
            throw new Error(`unable to match pitch parameter from merging array for index ${i}`);
        }

        if (typeof(hitParameter) === 'undefined') {
            throw new Error(`unable to match hit parameter from merging array for index ${i}`);
        }

        const pitchParamName = pitchParameter[pitchParameter.length - 1];
        const hitParamName = hitParameter[hitParameter.length - 1];
        const uniqueParamsMerged = [...new Set(
            uniqueParamsForPitches.get(pitchParamName).concat(uniqueParamsForHits.get(hitParamName))
        )];

        uniqueParams.set(pitchParamName, uniqueParamsMerged);
    }

    // for pitches only
    for (let p = 0; p < pitchParameters.length; p++) {
        if (typeof(pitchToHitParamsToMerge[p]) !== 'undefined'){
            // already added
            continue;
        }

        const pitchParameter = pitchParameters[p];
        const pitchParamName = pitchParameter[pitchParameter.length - 1];
        uniqueParams.set(pitchParamName, uniqueParamsForPitches.get(pitchParamName));
    }

    // for hits only
    for (let h = 0; h < hitParameters.length; h++) {
        if (pitchToHitParamsToMerge.indexOf(h) !== -1) {
            // already added
            continue;
        }

        const hitParameter = hitParameters[h];
        const hitParamName = hitParameter[hitParameter.length - 1];
        uniqueParams.set(hitParamName, uniqueParamsForHits.get(hitParamName));
    }

    return uniqueParams;
};

export default UniqueParametersForPitchAndHitProvider;